<template>
<div>
    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        <router-link to="/dashboard" class="text-white pl-3">
            <i class="ni ni-tv-2"></i> Dashborad
        </router-link><i class="ni ni-bold-right text-white"></i>     
        <span class="text-white"><i class="ni ni-bold-right"></i>Member</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
        <card header-classes="bg-transparent">
            <div v-if="openform">
                <div class="card bg-secondary border-0 mb-0">
                    <div class="card-body">
                        <div class="form-horizontal">
                            <form role="form" @submit.prevent="submitdata">
                                 <div class="row">
                                            <div class="col-md-12 pb-2">
                                                <img v-if="uploadedimage" height="100" :src="uploadedimage">
                                                <img v-else height="100" src="img/brand/empty.png"><br>                                 

                                                <input type="file" id="file" ref="file" class="inputfile inputfile-1" v-on:change="handleFileUpload()">                                               
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>First Name</label>
                                                    <input v-model="FirstNameval" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Middle Name</label>
                                                    <input v-model="MiddleNameval" class="form-control">
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Last Name</label>
                                                    <input v-model="LastNameval" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Email Address</label>
                                                    <input v-model="EmailAddressval" type="email" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Phone Number</label>
                                                    <input v-model="PhoneNoval" type="phone" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Date of Birth</label>
                                                    <input v-model="DateofBirthval" type="date" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Address</label>
                                                   <vue-google-autocomplete
                                                        ref="address"
                                                        id="map"
                                                        classname="form-control"
                                                        placeholder="Please type the address"
                                                        v-on:placechanged="getAddressData"
                                                        class="form-control"
                                                    >
                                                    </vue-google-autocomplete>
                                                                                                       
                                                      <input type="hidden" v-model="GoogleAddressval" />
                                                       <input type="hidden" v-model="Longitudeval" />
                                                        <input type="hidden" v-model="Latitudeval" />
                                                </div>
                                            </div>  
                                             <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Address Description</label>
                                                    <textarea v-model="AddressDescriptionval" class="form-control" rows="2" required></textarea>
                                                   
                                                </div>
                                            </div>   
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Who is He/she</label>
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <base-checkbox class=" ml-4" v-model="IsAdminval">
                                                                Admin
                                                            </base-checkbox>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <base-checkbox class=" ml-4" v-model="IsPastorval">
                                                                Pastor
                                                            </base-checkbox>
                                                        </div>
                                                    
                                                    </div>
                                                </div>
                                            </div>  
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Sex</label>
                                                     <select v-model="Sexval" class="form-control">
                                                        <option value="0"></option>
                                                        <option v-for="item in sex" :key="item" :value="item">{{item}} </option>                                                                                                            
                                                    </select>
                                                </div>
                                            </div> 
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Marital Status</label>
                                                     <select v-model="MaritalStatusval" class="form-control">
                                                        <option value="0"></option>
                                                        <option v-for="item in maritalStatus" :key="item" :value="item">{{item}} </option>                                                                                                            
                                                    </select>
                                                </div>
                                            </div>  
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Family</label>
                                                     <select v-model="FamilyIdval" class="form-control">
                                                        <option value="0"></option>
                                                        <option v-for="item in familyitems" :key="item.Id" :value="item.Id">{{item.FamilyName}} </option>                                                                                                            
                                                    </select>
                                                </div>
                                            </div>                                   
                                        </div>                                                              
                                <hr>
                                <div class="text-center mb-3">
                                    <button type="button" @click.stop="closeform()" class="btn btn-secondary">Cancel</button>
                                    <button type="submit" class="btn btn-primary my-4">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="form-inline">
                    <button type="button" @click.prevent="newterm" class="btn btn-default"><i class="ni ni-fat-add"></i>Add New </button>
                    <div class=" input-group">
                        <input v-model="searchval" class="form-control" @keyup="getsearch" placeholder="Search...">
                        <div class=" input-group-append">
                            <button type="button" @click.prevent="getsearch" class="btn btn-secondary"><i class="fa fa-search"></i> Search </button>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-border">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Email Address</th>
                                <th>Sex</th>
                                <th>Marital Status</th>
                                <th>Family</th>
                                <th>Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in resultitems" :key="item.Id">
                                <td> <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item.Id)"><i class="fa fa-edit"></i> Edit</button>  </td>
                                <td><img v-if="item.PassportPath" :src="$store.state.auth.baseurl + item.PassportPath.substr(1)" class=" rounded-circle" alt="" height="30">
                                <img v-else src="img/brand/loguser.png" class="rounded-circle" alt="" height="30" /></td>
                                <td>{{item.FullName}}</td>
                                <td>{{item.PhoneNo}}</td>
                                <td>{{item.EmailAddress}}</td>
                                <td>{{item.Sex}}</td>
                                <td>{{item.MaritalStatus}}</td>
                                <td>{{item.FamilyName}}</td>
                                <td>{{item.AddressDescription}}</td>
                            </tr>
                        </tbody>
                    </table>                   
                </div>
            </div>
        </card>
    </div>
</div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {
    mapState
} from 'vuex'
export default {
    components: { VueGoogleAutocomplete },
    name: 'member',
    data() {
        return {
            Idval: 1,
            address:'',
            FirstNameval: '',
            MiddleNameval: '',
            LastNameval: '',
            EmailAddressval: '',
            PhoneNoval: '',
            Sexval:'',
            MaritalStatusval:'',
            DateofBirthval: '',
            AddressDescriptionval: '',           
            GoogleAddressval:'',
            Longitudeval:'',
            Latitudeval:'',
            IsPastorval: '',
            IsAdminval: '',
            FamilyIdval: '', 
            ContactIdval: 1,          
            PassportPathval: '', 
            familyitems:null,
            resultitems:null,          
            file: '',
            uploadedimage: '',
            searchval: '',
            process: 'N',
            openform: false,           
            onloader: 'none'
        }
    }, 
    computed: {
        ...mapState({
            sex: state => state.appdata.sex,
            maritalStatus: state => state.appdata.maritalStatus
        })
    },
    methods: {
        newterm: function () {
            this.FirstNameval= '';
            this.MiddleNameval= '';
            this.LastNameval= '';
            this.EmailAddressval= '';
            this.PhoneNoval= '';
            this.Sexval='';
            this.MaritalStatusval='';
            this.DateofBirthval= '';
            this.AddressDescriptionval= '';           
            this.GoogleAddressval='';
            this.Longitudeval='';
            this.Latitudeval='';
            this.IsPastorval= '';
            this.IsAdminval= '';
            this.FamilyIdval= '';          
            this.PassportPathval= '';                 
            this.file = '';
            this.uploadedimage = '';           
            this.openform = true;
            this.process = 'N';            
        },
        closeform: function () {
            this.FirstNameval= '';
            this.MiddleNameval= '';
            this.LastNameval= '';
            this.EmailAddressval= '';
            this.PhoneNoval= '';
            this.Sexval='';
            this.MaritalStatusval='';
            this.DateofBirthval= '';
            this.AddressDescriptionval= '';           
            this.GoogleAddressval='';
            this.Longitudeval='';
            this.Latitudeval='';
            this.IsPastorval= '';
            this.IsAdminval= '';
            this.FamilyIdval= '';          
            this.PassportPathval= '';             
            this.file = '';
            this.uploadedimage = '';
            this.openform = false;
            this.process = 'N';
            this.inputdisable = false;
        },   
        getAddressData: function (addressData, placeResultData, id) {
           // this.address  = addressData;
           this.Longitudeval=addressData.longitude;
           this.Latitudeval=addressData.latitude;
           this.GoogleAddressval=placeResultData.formatted_address;
           console.log(id);

        },    
        edititem: function (Id) {
            this.onloader = 'flex'
            this.$store.dispatch('getmemberbyid', Id)
                .then(resp => {                   
                    this.Idval = resp.Id;
                    this.ContactIdval = resp.ContactId;
                    if (resp.PassportPath != null) {
                        this.uploadedimage = this.$store.state.auth.baseurl + resp.PassportPath.substr(1);
                    }
                    this.FirstNameval= resp.FirstName;
                    this.MiddleNameval= resp.MiddleName;
                    this.LastNameval= resp.LastName;
                    this.EmailAddressval= resp.EmailAddress;
                    this.PhoneNoval= resp.PhoneNo;
                    this.Sexval=resp.Sex;
                    this.MaritalStatusval=resp.MaritalStatus;
                    this.DateofBirthval= this.frontEndDateFormat(resp.DateofBirth);
                    this.AddressDescriptionval= resp.AddressDescription;           
                    this.GoogleAddressval=resp.GoogleAddress;
                    this.Longitudeval=resp.Longitude;
                    this.Latitudeval=resp.Latitude;
                    this.IsPastorval= resp.IsPastor;
                    this.IsAdminval= resp.IsAdmin;
                    this.FamilyIdval= resp.FamilyId;     
                    this.Sexval=resp.Sex.trim();
                    this.MaritalStatusval=resp.MaritalStatus.trim();     
                    this.PassportPathval= resp.PassportPath;                  
                    this.openform = true;
                    this.process = 'U';
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },     
        submitdata: function () {
            let Id = this.Idval;
            let FirstName = this.FirstNameval;
            let MiddleName= this.MiddleNameval;
            let LastName= this.LastNameval;
            let EmailAddress = this.EmailAddressval;
            let PhoneNo = this.PhoneNoval;
            let Sex = this.Sexval;
            let MaritalStatus = this.MaritalStatusval;
            let DateofBirth = this.DateofBirthval;
            let AddressDescription = this.AddressDescriptionval;           
            let GoogleAddress = this.GoogleAddressval;
            let Longitude = this.Longitudeval;
            let Latitude = this.Latitudeval;
            let IsPastor = this.IsPastorval;
            let IsAdmin = this.IsAdminval;
            let FamilyId = this.FamilyIdval;    
            let ContactId = this.ContactIdval;      
            let PassportPath = this.PassportPathval;
            let Operation = this.process;
            let Username = this.$store.state.auth.token;         
            this.onloader = 'flex';
            let userdata={Id, FirstName, MiddleName, LastName, EmailAddress, PhoneNo,Sex, MaritalStatus, DateofBirth,GoogleAddress,Longitude,Latitude, IsPastor, IsAdmin, FamilyId, ContactId, PassportPath, AddressDescription, Operation, Username}           
            this.$store.dispatch('processmember', userdata)
                .then((resp) => {
                    this.resultitems = resp;
                    this.closeform();
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Submitted successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getmember: function () {
            this.onloader = 'flex'
            this.$store.dispatch('getmember')
                .then((resp) => {
                    this.resultitems = resp;
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getsearch: function () {
            this.$store.dispatch('getmemberbysearch', this.searchval)
                .then((resp) => {
                    this.resultitems = resp;
                    //console.log(resp)
                })
                .catch(err => {
                    this.checkresponse(err.response.data);
                })
        },   
        getfamily: function () {
            this.onloader = 'flex'
            this.$store.dispatch('getfamily')
                .then((resp) => {
                    this.familyitems = resp;
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },  

        handleFileUpload: function () {
            this.file = this.$refs.file.files[0];
            this.submitFile();
        },
        submitFile: function () {
            this.onloader = 'flex'
            var form = new FormData();
            let username = this.$store.state.auth.token;          
            let formalurl = this.PassportPathval;
            let doctype = 'image';
            form.append('username', username)          
            form.append('formalurl', formalurl)
            form.append('doctype', doctype)
            form.append('file', this.file)
            this.$store.dispatch('uploadfile', form)
                .then((resp) => {
                    this.PassportPathval = resp;
                    this.uploadedimage = this.$store.state.auth.baseurl + resp.substr(1)
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Uploaded successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        frontEndDateFormat: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat: function (date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },
        checkresponse: function (resp) {
            if (resp === "Access Expired" || resp === "Invalid Credential") {
                this.$store.dispatch('logout');
                this.$router.push('/login')
            } else {
                console.log(resp);
            }
        }

    },
    mounted() {
        if (this.$store.state.auth.user_status_id != 2) {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        } else { 
               
            this.getmember();
            this.getfamily();
        }

    }
};
</script>

<style>

</style>
